var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHoldOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    fill: "#5F94D8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_231_299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.8946 42.6263V47.7579C47.8966 48.2343 47.799 48.7058 47.6081 49.1423C47.4173 49.5788 47.1374 49.9706 46.7863 50.2927C46.4353 50.6147 46.0209 50.8599 45.5696 51.0125C45.1183 51.1651 44.6401 51.2218 44.1657 51.179C38.9021 50.607 33.8461 48.8084 29.4038 45.9276C25.2709 43.3014 21.7669 39.7974 19.1407 35.6645C16.2499 31.2021 14.4508 26.1214 13.8894 20.8342C13.8466 20.3612 13.9028 19.8845 14.0544 19.4344C14.206 18.9843 14.4497 18.5707 14.7699 18.2199C15.0901 17.8691 15.4798 17.5889 15.9143 17.397C16.3487 17.2051 16.8184 17.1057 17.2933 17.1053H22.4249C23.255 17.0971 24.0598 17.3911 24.6892 17.9324C25.3187 18.4737 25.7298 19.2254 25.846 20.0474C26.0625 21.6896 26.4642 23.302 27.0433 24.854C27.2735 25.4662 27.3233 26.1316 27.1868 26.7712C27.0504 27.4109 26.7335 27.9981 26.2736 28.4632L24.1012 30.6355C26.5362 34.9179 30.082 38.4637 34.3644 40.8987L36.5367 38.7263C37.0018 38.2664 37.589 37.9495 38.2287 37.8131C38.8683 37.6766 39.5337 37.7264 40.146 37.9566C41.6979 38.5357 43.3103 38.9374 44.9525 39.154C45.7834 39.2712 46.5423 39.6897 47.0848 40.3299C47.6272 40.9702 47.9155 41.7874 47.8946 42.6263Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_231_299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.7723 16.6971C42.7723 16.1449 42.3245 15.6971 41.7723 15.6971H38.9214C38.3691 15.6971 37.9214 16.1449 37.9214 16.6971V28.1007C37.9214 28.6529 38.3691 29.1007 38.9214 29.1007H41.7723C42.3245 29.1007 42.7723 28.6529 42.7723 28.1007V16.6971Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7547 16.6971C50.7547 16.1449 50.307 15.6971 49.7547 15.6971H46.9038C46.3515 15.6971 45.9038 16.1449 45.9038 16.6971V28.1007C45.9038 28.6529 46.3515 29.1007 46.9038 29.1007H49.7547C50.307 29.1007 50.7547 28.6529 50.7547 28.1007V16.6971Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_231_299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 41,
    fill: "white",
    transform: "translate(10 14)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_231_299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.1053,
    height: 17.1053,
    fill: "white",
    transform: "translate(34.645 13.8463)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoldOn);
export default __webpack_public_path__ + "static/media/holdOn.58241ca32fb2089048dfd71359257430.svg";
export { ForwardRef as ReactComponent };